const searchItemUrl = query => {
	const baseUrl = window?.location?.origin;
	const parameterName = 'text';

	return `${baseUrl}/query?${parameterName}=${encodeURIComponent(query)}`;
};

export default searchItemUrl;
